
import React from 'react'
import styled from 'styled-components'
import { useTable } from 'react-table'
import { Link } from 'react-router-dom'
import cn from "classnames";
import Master from "screen/Master";
import styles from "../PriceInvoiceTable.module.scss";


const Styles = styled.div`
padding: 1rem;

table {
  border-spacing: 0;
  border: 0px solid black;
  font-size: smaller;
  width:100%;
  text-align: center;
  margin: -47px 0px 0px -6px;

  tr {
    :last-child {
      td {
        border-bottom: 0;
      }
    }
  }
}
tbody{
    text-align: center;
}
// tr:hover { 
//   background-color:#DEE2E6;
//   text-align: center;
// }
th {
  background-color: #F5F5FF;
  color: #343A40;
}
td{
  border: 1px rgb(201, 204, 216);
  border-style: solid none solid none;
}
th,
td { 
  padding: 10px;
}

  :last-child {
    border-right: 0;
  }
}
}

`

function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })

  // Render the UI for your table
  return (
    // <table {...getTableProps()}>
    //   <thead>
    //     {headerGroups.map(headerGroup => (
    //       <tr {...headerGroup.getHeaderGroupProps()}>
    //         {headerGroup.headers.map(column => (
    //           <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    //         ))}
    //       </tr>
    //     ))}
    //   </thead>
    //   <tbody {...getTableBodyProps()}>
    //     {rows.map((row, i) => {
    //       prepareRow(row)
    //       return (
    //         <tr {...row.getRowProps()}>
    //           {row.cells.map(cell => {
    //             return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
    //           })}
    //         </tr>
    //       )
    //     })}
    //   </tbody>
    // </table>
    <div></div>
  )
}

function App(data) {
 {console.log(data)}
  const columns = React.useMemo(
    () => [
      {
        Header: ' ',
        columns: [
          {
            Header: 'Price Name',
            accessor: 'pricename',
          },
          {
            Header: 'Unit Price',
            accessor: 'unitprice',
          },
          {
            Header: 'Status',
            accessor: 'status',
          },
        ],
      },
    ],
    []
  )

  var data=[
    {"pricename":"INV0001","unitprice":'Ajay Kumar',"status":'9876'},
    {"pricename":"INV0002","unitprice":'Ajay Kumar',"status":'9876'},
    {"pricename":"INV0003","unitprice":'Ajay Kumar',"status":'9876'},
    {"pricename":"INV0004","unitprice":'Ajay Kumar',"status":'9876'},
    {"pricename":"INV0005","unitprice":'Ajay Kumar',"status":'9876'},
    
  ];

  return (
    // <Styles>
    //   <Table columns={columns} data={data} />
    // </Styles>

<div className={cn(styles.flex_item1)}>
        <div className={cn(styles.flex1)}>
          <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
            {"Invoice"}
          </h2>

          <div className={cn(styles.group, styles.group_layout)}>
            <form>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>
                  {"Invoice Details"}
                </h3>
                <hr className={cn(styles.line, styles.line_layout)} />
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Invoice No"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        ////disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Invoice Date"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>
                </div>
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"VIN"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Driver Name"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div className={cn(styles.flex2, styles.flex2_layout)}></div>
          </div>
          {/* //------- */}

          <div className={cn(styles.group, styles.group_layout)}>
            <form>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>
                  {"Swap Details"}
                </h3>
                <hr className={cn(styles.line, styles.line_layout)} />
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Swap Site Name"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Swap Station Number"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div className={cn(styles.flex2, styles.flex2_layout)}></div>
          </div>
          {/* /// */}

          <div className={cn(styles.group, styles.group_layout)}>
            <form>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>
                  {"Battery Details"}
                </h3>
                <hr className={cn(styles.line, styles.line_layout)} />
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Existing BAttery A"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Exchanged Battery A"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>
                </div>
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Current Change"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Current Change"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>
                </div>
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Existing BAttery B"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Exchanged Battery B"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>
                </div>
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Current Changed"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Current Changed"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div className={cn(styles.flex2, styles.flex2_layout)}></div>
          </div>
          {/* //------- */}
          <div className={cn(styles.group, styles.group_layout)}>
            <form>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>
                  {"Energy Details"}
                </h3>
                <hr className={cn(styles.line, styles.line_layout)} />
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Total Energy Recieved"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Total Energy Given"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>
                </div>
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Current Changed"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Current Changed"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value="abc"
                        //disabled={onlyView || readOnlyField}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div className={cn(styles.flex2, styles.flex2_layout)}></div>
          </div>
          <div className={cn(styles.group, styles.group_layout)}>
            <form>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Unit Energy Cost"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"30"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Total Energy Exchanges (in KWH)"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"100KWH"}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Total Energy Exchanged(in INR)"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"3000 INR"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Mode of Payment"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Wallet"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div className={cn(styles.flex2, styles.flex2_layout)}></div>
          </div>

          {/* -- */}

          <div className={cn(styles.group, styles.group_layout)}>
            <div className={cn(styles.flex3, styles.flex3_layout)}>
              <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>
                {"Tax Details"}
              </h3>
              <hr className={cn(styles.line, styles.line_layout)} />
              {/* <div className={cn(styles.flex2, styles.flex2_layout)}> */}
              {/* <div className={cn(styles.flex2_item)}> */}
              {/* <div className={cn(styles.block3, styles.block3_layout)}> */}
              {/* <Styles> */}
              <Table columns={columns} data={data} />
              {/* </Styles> */}
              {/* </div> */}
              {/* </div> */}
              {/* <div className={cn(styles.flex2_spacer)} /> */}
              {/* </div> */}
              <div className={cn(styles.group1, styles.group1_layout)}>
                <form>
                  <div className={cn(styles.flex3, styles.flex3_layout)}>
                    <div className={cn(styles.flex2, styles.flex2_layout)}>
                      <div className={cn(styles.flex2_spacer)} />
                      <div className={cn(styles.flex2_item)}>
                        <div
                          className={cn(styles.block3, styles.block3_layout)}
                        >
                          <div
                            className={cn(
                              styles.text2_body,
                              styles.text2_body_layout
                            )}
                          >
                            {"150 Total Tax Amount"}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={cn(styles.flex2, styles.flex2_layout)}>
                      <div className={cn(styles.flex2_item)}>
                        <div
                          className={cn(styles.block3, styles.block3_layout)}
                        >
                          <div
                            className={cn(
                              styles.text1_body,
                              styles.text1_body_layout
                            )}
                          >
                            {"Total Amount To Pay(in INR)"}
                          </div>
                          <div
                            className={cn(
                              styles.text1_body,
                              styles.text1_body_layout
                            )}
                          >
                            {"3150"}
                          </div>
                        </div>
                      </div>

                      <div className={cn(styles.flex2_spacer)} />
                      <div className={cn(styles.flex2_item)}>
                        <div
                          className={cn(styles.block3, styles.block3_layout)}
                        >
                          <div
                            className={cn(
                              styles.text_body,
                              styles.text_body_layout
                            )}
                          >
                            {"Remarks"}
                          </div>
                          <input
                            placeholder="Enter Remarks Here"
                            className={cn(styles.line1, styles.line1_layout)}
                            value="abc"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <div className={cn(styles.flex9, styles.flex9_layout)}>
          <div className={cn(styles.flex9_item)}>
            <div
              className={cn(styles.block7, styles.block7_layout)}
              style={{ cursor: "pointer" }}
            >
              <h5 className={cn(styles.highlights1, styles.highlights1_layout)}>
                {"Cancel"}
              </h5>
            </div>
          </div>
          {/* <div className={cn(styles.flex9_spacer)} />
          <div className={cn(styles.flex9_item)}>
            <div
              className={cn(styles.block8, styles.block8_layout)}
              style={{ cursor: "pointer" }}
            >
              <h5 className={cn(styles.highlights2, styles.highlights2_layout)}>
                {"Submit"}
              </h5>
            </div>
          </div> */}
        </div>
              </div>

              {/* //------- */}
            </div>
          </div>
        </div>
      </div>
  );
}


 

export default App

